let personalitiesData = [
  {
    "name": "Weak",
    "tag": "physical"
  },
  {
    "name": "Athletic",
    "tag": "physical"
  },
  {
    "name": "Strong",
    "tag": "physical"
  },
  {
    "name": "Glamorous",
    "tag": "physical"
  },
  {
    "name": "Cute",
    "tag": "physical"
  },
  {
    "name": "Frightening",
    "tag": "physical"
  },
  {
    "name": "Attractive",
    "tag": "physical"
  },
  {
    "name": "Tough",
    "tag": "physical"
  },
  {
    "name": "Dominating",
    "tag": "physical"
  },
  {
    "name": "Badass",
    "tag": "physical"
  },
  {
    "name": "Ordinary",
    "tag": "physical"
  },
  {
    "name": "Bizarre",
    "tag": "physical"
  },
  {
    "name": "Flamboyant",
    "tag": "physical"
  },
  {
    "name": "Enthusiastic",
    "tag": "emotional"
  },
  {
    "name": "Fun-loving",
    "tag": "emotional"
  },
  {
    "name": "Passionate",
    "tag": "emotional"
  },
  {
    "name": "Troublesome",
    "tag": "emotional"
  },
  {
    "name": "Miserable",
    "tag": "emotional"
  },
  {
    "name": "Aggressive",
    "tag": "emotional"
  },
  {
    "name": "Anxious",
    "tag": "emotional"
  },
  {
    "name": "Intense",
    "tag": "emotional"
  },
  {
    "name": "Reserved",
    "tag": "emotional"
  },
  {
    "name": "Cowardly",
    "tag": "negative"
  },
  {
    "name": "Arrogant",
    "tag": "negative"
  },
  {
    "name": "Malicious",
    "tag": "negative"
  },
  {
    "name": "Deceitful",
    "tag": "negative"
  },
  {
    "name": "Obnoxious",
    "tag": "negative"
  },
  {
    "name": "Sleazy",
    "tag": "negative"
  },
  {
    "name": "Selfish",
    "tag": "negative"
  },
  {
    "name": "Power-hungry",
    "tag": "negative"
  },
  {
    "name": "Cocky",
    "tag": "negative"
  },
  {
    "name": "Hardworking",
    "tag": "positive"
  },
  {
    "name": "Incorruptible",
    "tag": "positive"
  },
  {
    "name": "Familial",
    "tag": "positive"
  },
  {
    "name": "Lovable",
    "tag": "positive"
  },
  {
    "name": "Heroic",
    "tag": "positive"
  },
  {
    "name": "Humble",
    "tag": "positive"
  },
  {
    "name": "Perfect",
    "tag": "distinguished"
  },
  {
    "name": "Cultured",
    "tag": "distinguished"
  },
  {
    "name": "Elegant",
    "tag": "distinguished"
  },
  {
    "name": "Stoic",
    "tag": "distinguished"
  },
  {
    "name": "Wise",
    "tag": "distinguished"
  },
  {
    "name": "Authoritarian",
    "tag": "distinguished"
  },
  {
    "name": "Confident",
    "tag": "mental"
  },
  {
    "name": "Distracted",
    "tag": "mental"
  },
  {
    "name": "Calculating",
    "tag": "mental"
  },
  {
    "name": "Unstable",
    "tag": "mental"
  },
  {
    "name": "Tranquilo",
    "tag": "mental"
  },
  {
    "name": "Fearless",
    "tag": "mental"
  },
  {
    "name": "Intelligent",
    "tag": "mental"
  },
  {
    "name": "Unpredictable",
    "tag": "mental"
  },
  {
    "name": "Extreme",
    "tag": "mental"
  },
  {
    "name": "Naive",
    "tag": "social"
  },
  {
    "name": "Solitary",
    "tag": "social"
  },
  {
    "name": "Charismatic",
    "tag": "social"
  },
  {
    "name": "Impressive",
    "tag": "social"
  },
  {
    "name": "Trusting",
    "tag": "social"
  }
];

export {personalitiesData}